import type { FeatureFlags } from '#shared/types'

export const useFeatureFlags = () => {
    const { public: { flags } } = useRuntimeConfig()

    return flags as FeatureFlags
}
